// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Override Safari Dark Mode Styles */
@media (prefers-color-scheme: dark) {
    body {
      background-color: #ffffff;
      /* Light mode background color */
      color: #000000;
      /* Light mode text color */
    }
  
    .menu {
      background-color: #fff !important;
    }
  
    .menu li a {
      color: #000 !important;
    }
    .menu li a span.badge {
      background-color: #fff;
      color: #000;
    }
    .menu li a[aria-current="page"] {
      color: #fff !important;
    }
    .menu>li:hover a span.badge {
      color: #000 !important;
    }
  
    table,
    th,
    td,
    tbody,
    thead {
      background-color: #fff;
    }
  
    *,
    ::before,
    ::after {
      box-sizing: border-box;
      border-width: 0;
      border-style: solid;
      border-color: #e5e7eb;
    }
  
    .bg-base-100 {
      background-color: #fff !important
    }
  
    .table :where(thead, tbody) :where(tr:not(:last-child)),
    .table :where(thead, tbody) :where(tr:first-child:last-child) {
      border-bottom-width: 1px;
      --tw-border-opacity: 1;
      /* border-bottom-color: var(--fallback-b2, oklch(var(--b2)))/var(--tw-border-opacity))); */
      border-bottom-color: #efefef;
    }
    .stat, .stats  {
      background-color: #fff !important;
    } 
    input.input {
      background-color: #fff !important;
    }
    .setCustomeColor {
      background-color: #fff !important;
    }
  
    /* input {
      background-color: #fff !important;
    } */
  }`, "",{"version":3,"sources":["webpack://./src/dark_them.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI;MACE,yBAAyB;MACzB,gCAAgC;MAChC,cAAc;MACd,0BAA0B;IAC5B;;IAEA;MACE,iCAAiC;IACnC;;IAEA;MACE,sBAAsB;IACxB;IACA;MACE,sBAAsB;MACtB,WAAW;IACb;IACA;MACE,sBAAsB;IACxB;IACA;MACE,sBAAsB;IACxB;;IAEA;;;;;MAKE,sBAAsB;IACxB;;IAEA;;;MAGE,sBAAsB;MACtB,eAAe;MACf,mBAAmB;MACnB,qBAAqB;IACvB;;IAEA;MACE;IACF;;IAEA;;MAEE,wBAAwB;MACxB,sBAAsB;MACtB,0FAA0F;MAC1F,4BAA4B;IAC9B;IACA;MACE,iCAAiC;IACnC;IACA;MACE,iCAAiC;IACnC;IACA;MACE,iCAAiC;IACnC;;IAEA;;OAEG;EACL","sourcesContent":["/* Override Safari Dark Mode Styles */\n@media (prefers-color-scheme: dark) {\n    body {\n      background-color: #ffffff;\n      /* Light mode background color */\n      color: #000000;\n      /* Light mode text color */\n    }\n  \n    .menu {\n      background-color: #fff !important;\n    }\n  \n    .menu li a {\n      color: #000 !important;\n    }\n    .menu li a span.badge {\n      background-color: #fff;\n      color: #000;\n    }\n    .menu li a[aria-current=\"page\"] {\n      color: #fff !important;\n    }\n    .menu>li:hover a span.badge {\n      color: #000 !important;\n    }\n  \n    table,\n    th,\n    td,\n    tbody,\n    thead {\n      background-color: #fff;\n    }\n  \n    *,\n    ::before,\n    ::after {\n      box-sizing: border-box;\n      border-width: 0;\n      border-style: solid;\n      border-color: #e5e7eb;\n    }\n  \n    .bg-base-100 {\n      background-color: #fff !important\n    }\n  \n    .table :where(thead, tbody) :where(tr:not(:last-child)),\n    .table :where(thead, tbody) :where(tr:first-child:last-child) {\n      border-bottom-width: 1px;\n      --tw-border-opacity: 1;\n      /* border-bottom-color: var(--fallback-b2, oklch(var(--b2)))/var(--tw-border-opacity))); */\n      border-bottom-color: #efefef;\n    }\n    .stat, .stats  {\n      background-color: #fff !important;\n    } \n    input.input {\n      background-color: #fff !important;\n    }\n    .setCustomeColor {\n      background-color: #fff !important;\n    }\n  \n    /* input {\n      background-color: #fff !important;\n    } */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
